import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminLevelGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) { }
 
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const adminLevel = this.auth.getAdminLevel();
    const requiredLevel = route.data['minAdminLevel'] as number ?? 0;
    
    if (adminLevel !== null && adminLevel >= requiredLevel) {
      return true;
    }

    this.router.navigate(['/no-access']);
    return false;
  }
}
